import React, {FunctionComponent, TextareaHTMLAttributes, useEffect, useRef, useState} from "react";
import "./RephraseAnswer.scss";
import {GeneratedAnswerStyle} from "@coveo/headless";

type RephraseAnswerProps = {
    currentStyle: string;
    onChangeStyle: (answerStyle: GeneratedAnswerStyle) => void
}
type RephraseOption = {
    value: "default" | "step" | "bullet" | "concise";
    titleKey: string;
}
const options : RephraseOption[] = [
    {
        value: 'default',
        titleKey: 'Auto',
    },
    {
        value: 'step',
        titleKey: 'Steps',
    },
    {
        value: 'bullet',
        titleKey: 'Bullets',
    },
    {
        value: 'concise',
        titleKey: 'Summary',
    },
];

const RephraseAnswer = ({onChangeStyle, currentStyle} : RephraseAnswerProps) => {
    return (
        <div className="rephrase-answer-container">
            <div className="rephrase-label">Rephrase</div>
            <div className="rephrase-buttons-wrap">
                {options.map((item, index) => {
                    return <RephraseButton key={index} active={currentStyle === item.value} buttonType={item.value} title={item.titleKey} onChangeStyle={onChangeStyle}/>
                })}
            </div>
        </div>
    );
}

type RephraseButtonProps = {
  buttonType: "default" | "step" | "bullet" | "concise";
  active: boolean;
  title: string;
  onChangeStyle: (answerStyle: GeneratedAnswerStyle) => void
}
const RephraseButton = ({buttonType, active, title, onChangeStyle} : RephraseButtonProps) => {
    let iconButton = getIconButton(buttonType);
    let classNameEl = `rephrase-button rephrase-${buttonType}` + (active ? " active" : "")
    return (
        <button className={classNameEl} title={title} onClick={() => onChangeStyle(buttonType)}>
            {iconButton}
        </button>
    )
}
const getIconButton = (buttonType : string) => {
    let iconButton;
    switch (buttonType) {
        case "step":
            iconButton = (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" height="16" width="16">
                    <line strokeLinecap="round" stroke="currentColor" y2="3" x2="14.5" y1="3" x1="8.5"></line>
                    <path strokeLinejoin="round" strokeLinecap="round" stroke="currentColor" d="M2 2.77548L3.37137 4.16667L6 1.5"></path>
                    <line strokeLinecap="round" stroke="currentColor" y2="13" x2="14.5" y1="13" x1="8.5"></line>
                    <line strokeLinecap="round" stroke="currentColor" y2="8" x2="14.5" y1="8" x1="8.5"></line>
                    <path strokeLinejoin="round" strokeLinecap="round" stroke="currentColor" d="M2 12.7755L3.37137 14.1667L6 11.5"></path>
                    <path strokeLinejoin="round" strokeLinecap="round" stroke="currentColor" d="M2 7.77548L3.37137 9.16667L6 6.5"></path>
                </svg>
            );
            break;
        case "bullet":
            iconButton = (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" height="16" width="16">
                    <line strokeLinecap="round" stroke="currentColor" y2="3" x2="13.5" y1="3" x1="7.5"></line>
                    <line strokeLinecap="round" stroke="currentColor" y2="13" x2="13.5" y1="13" x1="7.5"></line>
                    <line strokeLinecap="round" stroke="currentColor" y2="8" x2="13.5" y1="8" x1="7.5"></line>
                    <circle fill="currentColor" r="1.5" cy="3" cx="3.5"></circle>
                    <circle fill="currentColor" r="1.5" cy="8" cx="3.5"></circle>
                    <circle fill="currentColor" r="1.5" cy="13" cx="3.5"></circle>
                </svg>
            );
            break;
        case "concise":
            iconButton = (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" height="16" width="16">
                    <path strokeLinejoin="round" strokeLinecap="round" stroke="currentColor" d="M7 13.5C7 14.0523 7.44772 14.5 8 14.5C8.55228 14.5 9 14.0523 9 13.5"></path>
                    <path stroke="currentColor" d="M11.5 7.05C11.5 8.20833 10.9538 9.23537 10.109 9.88341C9.82908 10.0981 9.53089 10.3663 9.31281 10.7201L9.26859 10.7918C8.99723 11.232 8.51709 11.5 8 11.5C7.48291 11.5 7.00277 11.232 6.73141 10.7918L6.68719 10.7201C6.46911 10.3663 6.17091 10.0981 5.89101 9.88341C5.04624 9.23537 4.5 8.20833 4.5 7.05C4.5 5.08351 6.07284 3.5 8 3.5C9.92716 3.5 11.5 5.08351 11.5 7.05Z"></path>
                    <path strokeLinecap="round" stroke="currentColor" d="M2.5 7.5L2 7.5"></path>
                    <path strokeLinecap="round" stroke="currentColor" d="M3.5 3.5L3.00001 3"></path>
                    <path strokeLinecap="round" stroke="currentColor" d="M14 7.5L13.5 7.5"></path>
                    <path strokeLinecap="round" stroke="currentColor" d="M13 3L12.5 3.5"></path>
                    <path strokeLinecap="round" stroke="currentColor" d="M8 2L8 1.5"></path>
                </svg>
            );
            break;
        default:
            iconButton = (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 16" height="16" width="15">
                    <line strokeLinecap="round" stroke="currentColor" y2="2.75" x2="13.5" y1="2.75" x1="1.5"></line>
                    <path strokeLinecap="round" stroke="currentColor" d="M1.5 12.75H7.5"></path>
                    <line strokeLinecap="round" stroke="currentColor" y2="7.75" x2="13.5" y1="7.75" x1="1.5"></line>
                </svg>
            );
    }
    return iconButton;
}

export default RephraseAnswer;
